define(['jquery', 'availabilityForm', 'rooms', 'offers', 'basket', 'polyfill'], function($, availabilityForm, rooms, offers, basket, polyfill) {
    var renderSelectedTab = function() {
        var $ajaxContainer = $('.ajax-content');

        if ($('[data-action="browse-rooms"]').hasClass('active')) {
            rooms.render($ajaxContainer);
        } else {
            offers.render($ajaxContainer);
        }
    };

    $('[data-action="browse-rooms"], [data-action="view-offers"]').click(function() {
        $('.tab .tab-link').removeClass('active');
        $(this).addClass('active');
        renderSelectedTab();
    });

    $('a[data-check-basket]').click(function(e) {
        if (!basket.hasItems()) {
            e.preventDefault();
        }
    });

    if (availabilityForm.getDirectOfferCode() !== '') {
        //set offer tab as active on load, offer.js will handle the request
        $('.tab .tab-link').removeClass('active');
        $('[data-action="view-offers"]').addClass('active');
    }

    if ($('#booking-form').length) {
        basket.get();
    }

    availabilityForm.setOnChange(renderSelectedTab);
    basket.setOnSuccess(renderSelectedTab);
    rooms.setOffersDependancy(offers);
    offers.setRoomsDependancy(rooms);
});